/**
 * Converts an array of items into a Map keyed by a specified property.
 *
 * @template T - The type of items in the array
 * @template K - The key property to use for the map
 * @param {T[]} items - The array of items to convert
 * @param {K} keyProp - The property name to use as the map key
 * @returns {Map} Map of items keyed by the specified property value
 */
export const toMap = <T, K extends keyof T>(items: T[], keyProp: K): Map<T[K], T> =>
  new Map(items.map((item) => [item[keyProp], item]));
